<div class="page-header">
  <app-page-title>
    <a page-title-action class="btn btn-primary btn-sm d-inline-flex align-items-center gap-2"
       [routerLink]="['/ws-settings', 'new']">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14"/>
        <path d="M12 5v14"/>
      </svg>
      <span>เพิ่มข้อมูล</span>
    </a>
  </app-page-title>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <form>
      <div class="d-flex align-items-center gap-2 flex-wrap master-filter-row">
        <div class="d-flex align-items-center gap-2 flex-wrap flex-auto">
          <div class="input-group input-group-sm master-search-group">
            <input type="text" class="form-control" name="searchQuery"
                   placeholder="ค้นหา ชื่อ API..."
                   [(ngModel)]="searchQuery"
                   (keyup.enter)="onSearchChange()"/>
            <button class="btn btn-default" (click)="onSearchChange()" type="button">
              <i class="bi bi-search"></i>
            </button>
          </div>
          <button type="reset" class="btn btn-sm btn-default" (click)="clearSearch()">ล้าง</button>
          <div class="master-status-filter ms-auto">
            <select class="form-select form-select-sm master-status-select" [(ngModel)]="stateFilter"
                    name="stateFilter" (ngModelChange)="onSearchChange()">
              <option [ngValue]="null">ทั้งหมด</option>
              <option [ngValue]="1">ใช้งาน</option>
              <option [ngValue]="0">ไม่ใช้งาน</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead class="bg-light">
        <tr>
          <th class="text-center w-60px">No.</th>
          <th nowrap>สถานะ</th>
          <th nowrap>ชื่อ API</th>
          <th nowrap class="text-center">คู่มือ</th>
          <th nowrap>ผู้บันทึก</th>
          <th nowrap>วันที่บันทึก</th>
          <th class="text-center bg-light sticky-col sticky-col-header sticky-col-manage-actions">
            รายละเอียด
          </th>
        </tr>
        </thead>
        <tbody>
          @if (isLoading()) {
            <tr>
              <td colspan="7" class="text-center py-5">กำลังโหลดข้อมูล...</td>
            </tr>
          } @else if (displayedItems().length === 0) {
            <tr>
              <td colspan="7" class="empty-cell">
                - ไม่มีข้อมูล -
              </td>
            </tr>
          } @else {
            @for (item of displayedItems(); track item.id; let i = $index) {
              <tr>
                <td class="text-center">{{ (page() - 1) * pageSize() + i + 1 }}</td>
                <td>
                  <button type="button" class="status-toggle"
                          [disabled]="togglingId() === item.id"
                          [title]="item.status === 1 ? 'คลิกเพื่อปิดใช้จัดการข้อมูล API' : 'คลิกเพื่อเปิดใช้จัดการข้อมูล API'"
                          (click)="toggleStatus(item)">
                    <app-status-badge size="sm"
                                      [variant]="item.status === 1 ? 'success' : 'danger'"
                                      [label]="item.status === 1 ? 'ใช้งาน' : 'ไม่ใช้งาน'"/>
                  </button>
                </td>
                <td>{{ item.apiDescription || '-' }}</td>
                <td class="text-center">
                  @if (item.apiManualUrl) {
                    <a [href]="item.apiManualUrl" target="_blank" rel="noopener" [title]="item.apiManual">
                      <i class="bi bi-file-pdf-fill text-danger fs-5"></i>
                    </a>
                  } @else {
                    <span class="text-muted">-</span>
                  }
                </td>
                <td nowrap>{{ item.createdName || item.lastUpdatedName || item.createdId || item.lastUpdatedId || '-' }}</td>
                <td nowrap>{{ (item.createdDate || item.lastUpdatedDate) | thaidatetime:{showTime:false} }}</td>
                <td class="text-center sticky-col sticky-col-cell sticky-col-manage-actions">
                  <div class="d-flex gap-1 align-items-center justify-content-center">
                    <a class="btn btn-sm btn-icon" [routerLink]="['/ws-settings', item.id]"
                       [queryParams]="{mode: 'view'}" title="ดูรายละเอียด">
                      <app-search-icon [size]="18"></app-search-icon>
                    </a>
                    <button type="button" class="btn btn-sm btn-icon" (click)="delete(item.id)" title="ลบ">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 6h18"/>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                        <line x1="10" x2="10" y1="11" y2="17"/>
                        <line x1="14" x2="14" y1="11" y2="17"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer bg-white d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <span class="me-2 text-body-secondary">แสดง</span>
      <app-pagesize-select [value]="pageSize()" (valueChange)="pageSize.set($event); load()"/>
      <span class="ms-2 text-body-secondary">จาก {{ collectionSize() }} รายการ</span>
    </div>
    <ngb-pagination [collectionSize]="collectionSize()"
                    [page]="page()"
                    [pageSize]="pageSize()"
                    [maxSize]="5"
                    [rotate]="true"
                    [boundaryLinks]="true"
                    (pageChange)="page.set($event); load()">
    </ngb-pagination>
  </div>
</div>
